'use client'

import { useNotification } from '@/src/components/context/notification.context'
import Notification from '@/src/components/personalized/notification'

export default function NotificationContainer() {
  const { notifications, removeNotification } = useNotification()

  return (
    <div className="pointer-events-none fixed inset-0 z-50">
      {notifications.map((notification) => (
        <Notification
          key={notification.id}
          type={notification.type}
          title={notification.title}
          message={notification.message}
          duration={notification.duration}
          onClose={() => removeNotification(notification.id)}
        />
      ))}
    </div>
  )
}
